import { render, staticRenderFns } from "./Aceites.vue?vue&type=template&id=177f494d"
import script from "./Aceites.vue?vue&type=script&lang=js"
export * from "./Aceites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports